module.exports = __webpack_public_path__ + "media/promo/hochland/images/h_logo-22a30afd28a7bfe2927f35d701ba32f7.png";